import api from './api';

// Talks to /api/work-centers/* — the budgeted work / cost centres for the
// active version + site. Version and site come from the x-budget-version-id /
// x-site-code headers (set by the api interceptor).
export const workCenterService = {
  // { centers, rates, costCenters, defaultCategories }
  getWorkCenters: async () => {
    const res = await api.get('/work-centers');
    return res.data;
  },

  // payload: { centers: [ ...upserted masters... ], rates: [ ...upserted rates... ] }
  saveWorkCenters: async (payload) => {
    const res = await api.put('/work-centers', payload);
    return res.data;
  },

  deleteWorkCenter: async (workCenterCode) => {
    const res = await api.delete('/work-centers', { data: { work_center_code: workCenterCode } });
    return res.data;
  },

  deleteCategory: async (workCenterCode, rateCategory) => {
    const res = await api.delete('/work-centers/category', { data: { work_center_code: workCenterCode, rate_category: rateCategory } });
    return res.data;
  },
};

export default workCenterService;
